import { FC } from "react";
import styles from "./index.module.scss";
import classNames from "classnames";
import ChevronRight from "@/assets/images/ChevronRight";

interface OptionCardProps {
  title: string;
  info: string;
  suggested?: boolean;
  onClick: () => void;
  className?: string;
}

const OptionCard: FC<OptionCardProps> = ({ title, info, suggested, onClick, className }) => {
  return (
    <div
      className={classNames(
        styles.baseContainer,
        suggested && styles.suggestedContainer,
        className
      )}
      data-cy="option-card"
      onClick={onClick}>
      <div className={styles.contentContainer}>
        <span className={suggested ? styles.suggestedTitle : styles.title}>{title}</span>
        <span className={classNames(suggested && styles.suggestedInfo)}>{info}</span>
      </div>
      <ChevronRight className={styles.chevron} fill={suggested ? "white" : "black"} />
    </div>
  );
};

export default OptionCard;
